import React, { useState } from "react";
import { motion } from "framer-motion";
import EventSection from "../components/Events/EventSection";
import Eventgallery from "../components/Events/eventgallery";
import Footer from "../components/Footer";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Banner from "../components/EventsBanner";

function Offers() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };


  return (
    <>
    <Topbar />
      <Navbar />
      <Banner />
      {/* Staggered Sections */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ staggerChildren: 0.25 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
      >

        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <EventSection />
        </motion.div>  
        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <Eventgallery />
        </motion.div>          
      </motion.div>

      <Footer />
    </>
  );
}

export default Offers;
